<p *ngIf="(success$ | async) === false">
  Ошибка авторизации. Повторите позже или обратитесь в службу технической
  поддержки <a href="mailto:help@proleum.pro">help&#64;proleum.pro</a>.
</p>
